import { v4 as uuidv4 } from 'uuid'
import SleeveImageMapping from './assets/SleeveImageMapping'
import WireImageMapping from './assets/WireImageMapping'
const currencyFormatter = require('currency-formatter')
const prettyBytes = require('pretty-bytes')
const FileDownload = require('js-file-download')

export const projectName = 'Bayka Webapp'

export const backendDomain =
  process.env.NODE_ENV === 'production'
    ? 'https://backend-kabelnavigator.bayka.de'
    : 'http://localhost:8100'

export const getUUID = () => uuidv4()

export const getQueryString = (string, requiredString) => {
  if (typeof string === 'string' && string.length > 0 && typeof requiredString === 'string') {
    string = string.substring(1)
    const split = string.split('=')
    return !string.includes('&') &&
      split.length === 2 &&
      split[0] === requiredString &&
      split[1].length > 0
      ? decodeURIComponent(split[1])
      : false
  } else {
    return false
  }
}

export const triggerClientSideDownload = (data, filename) => FileDownload(data, filename)

export const getImage = (data) => {
  if (data.type === 'wire') {
    const foundMapping = WireImageMapping.find(
      (el) => el.TITYPN.toString() === data.artikelnummerbayka,
    )
    if (foundMapping) {
      const url = awsStorageBucketPrefix + 'product_pictures/' + foundMapping.Bild
      return url
    }
  } else if (data.type === 'sleeve') {
    const foundMapping = SleeveImageMapping.find((el) => el.id.toString() === data.id)
    if (foundMapping) {
      const url = awsStorageBucketPrefix + 'product_pictures/' + foundMapping.Bild
      return url
    }
  }
  return data.image
}

//export const awsStorageBucketPrefix = 'https://s3.eu-central-1.amazonaws.com/bayka-webapp.storage/'
export const awsStorageBucketPrefix = 'https://db.baykaplus.de/kabelnavigator/'

export const frontendDomain =
  process.env.NODE_ENV === 'production'
    ? 'https://kabelnavigator.bayka.de'
    : 'http://localhost:3000'

export const getPrettyTime = (date) => {
  // date.setMinutes(date.getMinutes() + (date.getTimezoneOffset() * -1))
  const fill = (number) => {
    number = `${number}`
    return number.length === 1 ? `0${number}` : number
  }
  const minute = fill(date.getMinutes())
  const hour = fill(date.getHours())
  return `${hour}:${minute}`
}
export const getPrettyDateTime = (date) => {
  // date.setMinutes(date.getMinutes() + (date.getTimezoneOffset() * -1))
  const fill = (number) => {
    number = `${number}`
    return number.length === 1 ? `0${number}` : number
  }
  const day = fill(date.getDate())
  const month = fill(date.getMonth() + 1)
  const year = date.getFullYear()
  const minute = fill(date.getMinutes())
  const hour = fill(date.getHours())
  return `${day}.${month}.${year} ${hour}:${minute}`
}
export const getPrettyDate = (date) => {
  const fill = (number) => {
    number = `${number}`
    return number.length === 1 ? `0${number}` : number
  }
  const day = fill(date.getDate())
  const month = fill(date.getMonth() + 1)
  const year = date.getFullYear()
  return `${day}.${month}.${year}`
}

export const addMissingZero = (input) => {
  if (`${input}`.length === 1) {
    return `0${input}`
  }
  return input
}

export const formatFileSize = (sizeInBytes, locale = 'de') => {
  return prettyBytes(sizeInBytes, { locale })
}

export const formatPrice = (priceInCents, locale = 'de-DE') => {
  return currencyFormatter.format(priceInCents / 100, { locale })
}

export const maxMobileWidth = 992

export const presignedUploadURLEndpoint = '/upload/get-presigned-url'

// format number with 1.000,00
// only format if string is number
export const formatNumber = (string) => {
  if (typeof string === 'string' && !isNaN(string)) {
    return string.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } else {
    return string
  }
}
